<script>
import isFunction from 'lodash/isFunction';
import Layout from '@layouts/main';
import UniversalModel from '@models/Universal';
import editFormChange from '@mixins/editFormChange';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  components: {
    Layout,
  },
  mixins: [editFormChange, beforeLeaveAfterEdit],
  metaInfo() {
    return {
      title: `Admin - Edit ${this.$route.meta.name || this.$route.meta.entity} "${this.entity.name}"`,
    };
  },
  data() {
    return {
      entity: {
        name: null,
        entity: this.$route.meta.entity,
      },
      fields: this.$route.meta.fields,
      breadcrumbItems: [
        {
          text: 'Admin',
          to: { name: 'home.index' },
        },
        {
          text: this.$route.meta.breadcrumbName ? this.$route.meta.breadcrumbName
              : this.$route.meta.name
            ? `${this.$route.meta.name.replace('y', 'ie')}s`
            : this.$route.meta.path.charAt(0).toUpperCase() + this.$route.meta.path.slice(1),
          to: { name: `${this.$route.meta.path}.index` },
        },
        {
          text: `Edit ${this.$route.meta.name || this.$route.meta.entity} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  mounted() {
    this.$wait.start('global loading');

    UniversalModel.params({
      entity: this.$route.meta.entity,
    })
      .find(this.$route.params.id)
      .then((response) => {
        this.entity = Object.assign({}, this.entity, response);
        this.$wait.end('global loading');
        this.$nextTick(() => {
          this.initBeforeLeave(false, this.updateEntity);
          this.initChangeWatcher(['entity']);
        });
      })
      .catch(() => this.$wait.end('global loading'));
  },
  methods: {
    updateEntity(callback) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$wait.start('global loading');

          new UniversalModel(this.entity)
            .save()
            .then(() => {
              this.setUnchanged();
              if (callback && isFunction(callback)) callback();
              this.$router.push({
                name: `${this.$route.meta.path}.index`,
              });
              this.$wait.end('global loading');
            })
            .catch(() => this.$wait.end('global loading'));
        }
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="`Edit ${$route.meta.name || $route.meta.entity}`"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
    >
      <b-form @submit.prevent="updateEntity">
        <b-form-group id="InputGroup1" label="Name:">
          <b-form-input
            id="name"
            v-model="entity.name"
            v-validate="'required|max:255'"
            data-vv-value-path="localValue"
            data-vv-name="name"
            data-vv-as="Name"
            type="text"
            :state="errors.has('name') ? false : null"
            aria-describedby="input-feedback-name"
            placeholder="Enter name"
          >
          </b-form-input>

          <b-form-invalid-feedback id="input-feedback-name">
            <template v-show="errors.has('name')">{{ errors.first('name') }}</template>
          </b-form-invalid-feedback>
        </b-form-group>

        <template v-if="fields && fields.length">
          <div v-for="field in fields" :key="field.label">
            <template v-if="field.type === 'boolean'">
              <b-form-group>
                <b-form-checkbox v-model="entity[field.name]" :value="1" :unchecked-value="0">
                  {{ field.label }}
                </b-form-checkbox>
              </b-form-group>
            </template>
            <template v-if="field.type === 'text'">
              <b-form-group :label="`${$t(`fields.${field.name}`)}`">
                <b-form-input
                  v-model="entity[field.name]"
                  v-validate="field.validation"
                  data-vv-value-path="localValue"
                  :data-vv-name="field.name"
                  :data-vv-as="field.name"
                  :placeholder="`${$t(`placeholders.${field.name}`)}`"
                  :state="errors.has(field.name) ? false : null"
                  :aria-describedby="`input-feedback-${field.name}`"
                >
                </b-form-input>

                <b-form-invalid-feedback :id="`input-feedback-${field.name}`">
                  <template v-show="errors.has(field.name)">{{ errors.first(field.name) }}</template>
                </b-form-invalid-feedback>
              </b-form-group>
            </template>
          </div>
        </template>

        <b-button :disabled="!!errors.items.length" type="submit" :variant="'outline-' + (!errors.items.length ? 'dark' : 'danger')">Submit</b-button>
      </b-form>
    </b-card>
  </Layout>
</template>
